import { Kaggle } from "@kaggle/sdk";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

export const competitionsPaneInfo = (
  state: Kaggle.Sdk.Kernels.GetCompetitionsPaneInfoResponse | null = null,
  action: NotebookAction
) => {
  switch (action.type) {
    case NotebookActionKey.SET_BEST_AND_LATEST_SCORES:
      return action.payload.competitionsPaneInfo;
    default:
      return state;
  }
};
